import React from 'react';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';

interface DropdownProps {
    id: string;
    options?: { value: string; label: string }[];
    resources: ILxsCreateOrderResources;
    label: string;
    value: string;
    disabled: boolean;
    onChange: (value: string) => void;
}

const Dropdown: React.FC<DropdownProps> = ({ id, options, resources, label, value, disabled, onChange }) => {
    return (
        <>
            <label htmlFor={id}>{label}</label>
            <select id={id} onChange={e => onChange(e.target.value)} value={value} disabled={disabled}>
                <option value=''>{resources.createOrderSearchDefaultOption}</option>
                {options?.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </>
    );
};

export default Dropdown;
